import React, { useCallback, useRef } from 'react';

import { useRefValue } from '.';

export const useCompleteVideo = (
  videoRef: React.RefObject<{ duration: number } | null>,
  onComplete?: () => void
) => {
  const onCompleteRef = useRefValue(onComplete);

  const totalPlayedTimeRef = useRef(0);
  const hasTriggeredCompleteRef = useRef(false);
  const intervalRef = useRef<number | null>(null);

  const stopTrackingProgress = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [intervalRef]);

  const startTrackingProgress = useCallback(() => {
    stopTrackingProgress(); // Prevent duplicate intervals
    intervalRef.current = window.setInterval(() => {
      const duration = videoRef.current?.duration;
      if (duration) {
        totalPlayedTimeRef.current++;

        if (
          !hasTriggeredCompleteRef.current &&
          totalPlayedTimeRef.current >= duration * 0.5
        ) {
          hasTriggeredCompleteRef.current = true;
          onCompleteRef.current?.();
        }
      }
    }, 1000);
  }, [intervalRef, videoRef, onCompleteRef, stopTrackingProgress]);

  return [startTrackingProgress, stopTrackingProgress];
};
